import autobiografia from './autobiografia.json';
import bor_borito from './bor_borito.json';
import canvas_dream from './canvas_dream.json';
import dekor_borito from './dekor_borito.json';
import finessa from './finessa.json';
import fotos_borito from './fotos_borito.json';
import la_fontana_di_stile from './la_fontana_di_stile.json';
import wedding_sensation from './wedding_sensation.json';
import calligrafia from './calligrafia.json';
import init from './../../cover_template.json';

export default {
  autobiografia,
  bor_borito,
  canvas_dream,
  dekor_borito,
  finessa,
  fotos_borito,
  la_fontana_di_stile,
  wedding_sensation,
  calligrafia,
  init,
};



// WEBPACK FOOTER //
// ./src/config/templates/covers/pro/square/index.jsx